module.exports = __webpack_public_path__ + "img/portal-icon-active.cbf4327a.svg";